<!-- =========================================================================================
  File Name: UserCreate.vue
  Description: User Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-create">
    <vue-element-loading :active="loading"></vue-element-loading>
    <div class="vx-row">
      <div class="vx-col w-full">
        <form-wizard
            :title="null"
            :subtitle="null"
            nextButtonText="Continue"
            finishButtonText="Create Contact"
            @on-complete="saveChanges"
            color="#1a1a1a"
        >
          <tab-content title="General Details" :before-change="validateStepOne">
            <user-profile-form
                ref="profile"
                v-model="profileModel"
            />
            <user-details-form
                ref="userDetailsForm"
                v-model="userDetailsModel"
            />
          </tab-content>
          <tab-content title="Addresses" :before-change="validateStepTwo">
            <user-addresses
                ref="addresses"
                v-model="addressesModel"
            />
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
              <vs-button class="my-4" v-if="props.activeTabIndex > 0" @click.native="props.prevTab()">Back</vs-button>
              <vs-button class="ml-4 my-4" @click="cancel">Cancel</vs-button>
            </div>
            <div class="wizard-footer-right">
              <vs-button color="light" v-if="!props.isLastStep" @click.native="props.nextTab()" class=" my-4">Continue</vs-button>
              <vs-button color="light" v-else @click.native="props.nextTab()" class=" finish-button my-4">  {{props.isLastStep ? 'Create Contact' : 'Continue'}}</vs-button>

            </div>
          </template>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>

import UserProfileForm from "../forms/UserProfileForm";
import FormValidateMixin from "../../../../components/mixins/FormValidateMixin";
import UserAddresses from '../forms/UserAddresses';

// Store Module
import progressBar from "../components/ProgressBar";
import {FormWizard, TabContent} from "vue-form-wizard";
import UserCreateAddresses from "./UserCreateAddresses";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import UserValidation from "@/validation/User";
import NotificationMixin from '../../../../components/mixins/NotificationMixin';
import SaveModelMixin from '../../../../components/mixins/SaveModelMixin';
import CanAccessMixin from '../../../../components/mixins/CanAccessMixin';
import FormModelMixin from '../../../../components/mixins/FormModelMixin';
import UserDetailsForm from '../forms/UserDetailsForm';
UserValidation.init();

export default {
  components: {
    UserProfileForm,
    progressBar,
    FormWizard,
    TabContent,
    UserCreateAddresses,
    UserDetailsForm,
    UserAddresses
  },
  inject: ['$validator'],

  data () {
    return {
      profileModel: {},
      userDetailsModel: {},
      addressesModel: {},

      profile_user_data: {}, // Should be removed
      contact_user_data: {}, // Should be removed
      user_not_found: false,
      internalLoading: false,
      addresses: [],
      forms: ['profile', 'addresses', 'contact'],
    }
  },
  mixins: [
    FormModelMixin,
    NotificationMixin,
    CanAccessMixin,
    SaveModelMixin,
    FormValidateMixin
  ],
  watch: {},
  methods: {
    validateForm() {
      return !this.vErrors.any();
    },
    async validateStepOne() {
      return await this.validateStep(['profile', 'userDetailsForm']);
    },
    async validateStepTwo() {
      return await this.validateStep(['addresses']);
    },
    async validateStep(formReferences) {
      try {
        this.internalLoading = true;

        this.formReferences = formReferences;

        if (!await this.validate()) {
          this.notifyError('Not all required fields have been provided');

          return false;
        }
      } catch (e) {
        this.addErrors(e);
        return false;
      } finally {
        this.internalLoading = false;
      }

      return true;
    },
    getParams() {
      const localData = this.setModelCopy({
        ...this.userDetailsModel,
        ...this.addressesModel,
        ...this.profileModel,
      });

      const references = [
        'Company_FK',
        'connection',
        'LearningLevelType_FK',
        'AddressType_FK',
      ];

      const multiReferences = [
        {
          array: 'applications',
          key: 'SelectedRoleId',
        },
        {
          array: 'class_of_business',
          key: 'ClassOfBusiness_FK',
        },
        {
          array: 'email_addresses',
          key: 'EmailType_FK',
        },
        {
          array: 'phone_numbers',
          key: ['PhoneType_FK', 'CountryCode'],
        },
        {
          array: 'external_links',
          key: 'LinkType_FK',
        },
        {
          array: 'profile',
          key: ['FisgRoleType_FK', 'LearningLevelType_FK'],
        },
      ];

      this.setMultiReferences(multiReferences, localData);
      this.setReferences(references, localData);

      localData.roleIds = localData.applications.filter(application => application.SelectedRoleId > 0)
        .map(application => application.SelectedRoleId);
      delete localData.applications;

      localData.addresses = [{
        IsPrimaryAddress: 1,
        AddressType_FK: localData.AddressType_FK,
        AddressLine1: localData.AddressLine1,
        AddressLine2: localData.AddressLine2,
        AddressLine3: localData.AddressLine3,
        City: localData.City,
        Country: localData.Country,
        PostCode: localData.PostCode,
        Province: localData.Province,
        Region: localData.Region,
      }];

      delete localData.AddressType_FK;
      delete localData.AddressLine1;
      delete localData.AddressLine2;
      delete localData.AddressLine3;
      delete localData.City;
      delete localData.Country;
      delete localData.PostCode;
      delete localData.Province;
      delete localData.Region;

      return localData;
    },
    async saveChanges() {
      try {
        const params = this.getParams();

        const { data } = await this.$api.users.create(params)

        this.notifySuccess('Contact was successfully created', 'Contact created');
        await this.$router.push({name: 'contact.list'});
      } catch (e) {
        this.notifyError(
            e.response.data.message || 'Not able to update contact. Please try again.',
            'Error occurred'
        );
      }
    },
    cancel() {
      this.$router.push({name: 'contact.list'});
    }
  },
}

</script>

<style lang="scss">
  .wizard-navigation {
    min-height: 875px;
  }

  .progress-container {
    .progress-bar {
      padding-right: 20px;
    }

    .progress-checkpoints {
      position: relative;
      top: -26px;
      z-index: 50;

      .step-one-checkpoint,
      .step-two-checkpoint {
        span {
          font-size: 16px;
          font-weight: bold;
          border: 1px solid #000;
          background-color: #000;
          display: inline-block;
          width: 38px;
          height: 38px;
          text-align: center;
          line-height: 38px;
          margin-right: 15px;
          border-radius: 20px;
          color: #fff;

          &.inactive {
            color: #000;
            background-color: #fff;
          }
        }
      }

      .step-one-checkpoint {
        span {
          margin-left: 35px;
        }
      }

      .step-two-checkpoint {
        text-align: right;
      }
    }
  }
</style>
